import gql from 'graphql-tag';

export default fields => gql`
mutation ($input: UpdateEtlQueryInput!) {
    updateEtlQuery (input: $input) {
        __typename
        ${[...['id', 'etlPackageId', 'icon', 'parent_ids', 'step', 'x', 'y', 
        'settings { name, tableId, compressed, manifest, escapeDelimiter, csvFile, delimiter, ignoreHeaderRows, copyOnly, copyFormatRegex }', 
        'columns { id, order, name, type, dataType, defaultValue, isIdentity, alias, maxLength, scale, defaultValueIsFunction }'].concat(fields)]}
    }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/EtlQueries/UpdateMutation.js